import { AnalyticsApplication } from '@landr/core';
import React, { useContext } from 'react';
import { DefaultNavBarFeatures } from '../../entrypoints/NavBar/navBarFeatures.es.js';
import { Languages } from '../../enums/languages.es.js';

var DefaultNavBarContextProps = {
  env: 'production',
  language: Languages.English,
  user: undefined,
  features: DefaultNavBarFeatures,
  isUserLoading: false,
  chatClientService: null,
  locationPathname: '',
  config: {
    applicationName: AnalyticsApplication.Platform,
    applicationVersion: '1',
    isLocal: false,
    authorizationToken: null,
    log: {}
  }
};
var NavBarContext = React.createContext(DefaultNavBarContextProps);
var useNavBarContext = function useNavBarContext() {
  return useContext(NavBarContext);
};

export { DefaultNavBarContextProps, NavBarContext, useNavBarContext };
